<template>
  <div class="point-enough">
    <h1 class="point-enough__title">ポイントを利用できるサービス</h1>
    <div class="service-menu">
      <div
        v-for="item in availableServices"
        :key="item.title"
        class="service-menu__item"
      >
        <a :href="item.url" class="service-menu__link">
          <h2 class="service-menu__title">{{ item.title }}</h2>
          <p class="service-menu__text">{{ item.description }}</p>
          <div class="service-menu__itemfoot">
          <link-icon :icon-type="item.type === 'text' ? 0 : 1"/>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import LinkIcon from "@/utvStore/components/partials/LinkIcon";
export default {
  name: 'PointEnough',
  components:{
    LinkIcon
  },
  props: {
    // 保有ポイント
    point: {
      type: Number,
      default: 0
    },
    // ポイントを利用できるサービス
    services: {
      type: Array,
      default () {
        return []
      }
    },
  },
  computed: {
    // 保有ポイントで利用できるサービスのみに絞る
    availableServices () {
      return this.services.filter(item => {
        // しきい値が、保有ポイント以下
        return item.thresholds <= this.point
      })
    }
  }
}</script>

<style lang="scss" scoped>
@import '../../../../sass/commons/commonVariables.scss';

.point-enough {
  margin: 0 -16px -20px;
  &__title {
    margin: 0;
    padding: 8px 20px;
    font-size: 12px;
    font-weight: normal;
    background: linear-gradient(64.31deg, rgba($col_temp_key1, 0.07) 18.23%, rgba($col_temp_key2, 0.07) 80.21%);
  }
}
.service-menu {
  &__item {
    border-bottom: 1px solid $col_temp_gray3;
  }
  &__link {
    display: block;
    min-height: 160px;
    padding: 20px;
    position: relative;
    color: inherit;
    text-decoration: none;
  }
  &__title {
    margin: 0 0 4px;
    font-weight: bold;
    font-size: 17px;
  }
  &__text {
    margin: 0 0 10px;
    font-size: 13px;
  }
  &__itemfoot{
    bottom: 15px;
    position: absolute;
    right: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/User/PointEnough.vue